import React, { useState, useEffect, useCallback, useMemo } from "react";
import axios from "axios";
import api from "../lib/axios";
import moment from "moment";
import StripeCheckout from "react-stripe-checkout";
import Playerreviewcard from "./Player_review_card";
import Modal from "./Modal";
import "../styles/css/Global-Style.css";
import "../styles/css/Review_order.css";
import usersService from "../services/usersService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./Checkout";
import WorldPayModal from "./WorldPayModal";
import { FaSpinner } from "react-icons/fa";
import {
  buildDeviceData,
  runChallenge,
  runDeviceDataCollection,
} from "../services/worldpay3ds";

const stripePromise = loadStripe(process.env.REACT_APP_PUBLISHABLE_KEY);

// Toggle between Stripe (default) and Worldpay via env. Set
// REACT_APP_PAYMENT_PROVIDER=worldpay in .env to use Worldpay.
const PAYMENT_PROVIDER = (process.env.REACT_APP_PAYMENT_PROVIDER || "stripe").toLowerCase();

const getWorldpayReturnUrl = () => {
  const apiBase =
    process.env.REACT_APP_API_URL ||
    (typeof window !== "undefined" ? window.location.origin + "/api/" : "/api/");
  const normalizedApiBase = String(apiBase).endsWith("/") ? apiBase : apiBase + "/";

  try {
    return new URL("worldpay/3ds/return", normalizedApiBase).toString();
  } catch (e) {
    if (typeof window !== "undefined") {
      return new URL("/api/worldpay/3ds/return", window.location.origin).toString();
    }
    return normalizedApiBase + "worldpay/3ds/return";
  }
};

// Lifted out of the component body so the Yup schema isn't rebuilt on every
// render (audit MEDIUM 14). useForm only reads `resolver` once anyway, but
// keeping the schema referentially stable also means yupResolver's internals
// don't see a fresh object each tick.
const reviewValidationSchema = Yup.object().shape({
  termsCondition: Yup.boolean().oneOf(
    [true],
    "Please accept terms and conditions"
  ),
});
const reviewFormOptions = { resolver: yupResolver(reviewValidationSchema) };

export default function ReviewOrder(props) {
  const [clientSecret, setClientSecret] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);

  const { register, handleSubmit, setError, formState, setValue } =
    useForm(reviewFormOptions);
  const { errors } = formState;

  const { prevStep, values, setFormData } = props;
  const [showModal, setShowModal] = useState(false);
  const [formSubmitError, setFormSubmitError] = useState("");
  const [termsconditionvalue, setTermsConditionValue] = useState(false);
  const [offerpromotionvalue, setOfferPromotionValue] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [couponCode, setCouponCode] = useState(() =>
    (new URLSearchParams(window.location.search).get("coupon") || "")
      .trim()
      .toUpperCase(),
  );
  const [couponDiscount, setCouponDiscount] = useState(0);
  const [couponMessage, setCouponMessage] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [isLoadingCoupon, setIsLoadingCoupon] = useState(false);
  const [couponDisplay, setCouponDisplay] = useState("");

  // Worldpay flow state (only used when PAYMENT_PROVIDER === "worldpay")
  const [showWorldpayModal, setShowWorldpayModal] = useState(false);
  const [isAPIProcessing, setIsAPIProcessing] = useState(false);
  const [transactionReference, setTransactionReference] = useState("");

  const originalRate = parseFloat(values.Player_Rate) || 0;
  const finalRate = Math.max(0, originalRate - couponDiscount).toFixed(2);

  let now = new Date();
  var todaydate = moment(now).format("yyyy-MM-DD[T]HH:mm:ss.SSS[Z]");
  var todaydateplusthreemonth = moment(todaydate).add(3, "M");

  // useCallback so memoized children (Playerreviewcard) don't re-render
  // when an unrelated piece of Review_order state (coupon, terms, etc.) flips.
  const backToPersonal = useCallback(() => {
    console.info("Back to personal info clicked", {
      AllDATA: values,
    });
    prevStep();
  }, [prevStep, values]);

  var createbookingentries = values.Player_Count;

  // Member / £0 booking (no card). Route through the same server-side
  // createCompleteBooking endpoint the Worldpay path uses (minus the card),
  // instead of creating booking/payment rows client-side — that legacy path
  // needed broad create permissions on the Authenticated role and is exactly
  // what produced "Issue with submitting form." for logged-in members.
  const submitMembership = async () => {
    console.info("Submit Membership", { AllDATA: values });
    setFormSubmitError("");
    setIsLoading(true);
    const reservationToken = localStorage.getItem("u_b_id_jwt") || "";
    const body = {
      user_token: reservationToken,
      user_data: {
        first_name: values.Player1Firstname,
        last_name: values.Player1Lastname,
        email: values.Player1Email,
        username: values.Player1Email,
        password: values.Player1Password,
        mobile_number: values.Player1Telephone,
      },
      booking_data: {
        tee_time_slot: parseInt(values.SelectedSlotId),
        BookingDate: moment(values.date).format("yyyy-MM-DD[T]HH:mm:ss.SSS[Z]"),
        Status: true,
        OtherPlayers: [],
        hasUserMembership: values.hasUserMembership,
        playerCount: values.Player_Count,
        coupon_code: couponApplied ? couponCode : "",
        coupon_discount: couponApplied ? couponDiscount : 0,
        shared_tee_accepted: !!values.shared_tee_accepted,
        shared_tee_context: values.shared_tee_context || "",
      },
      visitor_data: [],
      payment_data: {
        payment_type: "Membership",
        green_fees_amount: 0,
        total_amount: 0,
        token: "",
        coupon_code: couponApplied ? couponCode : "",
        discount_amount: couponApplied ? couponDiscount : 0,
      },
    };

    const _stamp = Date.now();
    for (let i = 2; i <= parseInt(values.Player_Count); i++) {
      const fname = values["Player" + i + "Firstname"];
      const lname = values["Player" + i + "Lastname"];
      const safeFirst = fname && fname !== "" ? fname : "Player " + i;
      const safeLast = lname && lname !== "" ? lname : "";
      const _email =
        "player-" +
        (values.SelectedSlotId || "x") +
        "-" +
        _stamp +
        "-" +
        i +
        "@golfteetime.co.uk";
      body.visitor_data.push({
        FirstName: safeFirst,
        LastName: safeLast,
        Email: _email,
        golf_courses: 1,
      });
      body.booking_data.OtherPlayers.push(
        safeLast ? safeFirst + " " + safeLast : safeFirst
      );
    }

    try {
      const response = await api.post("createCompleteBooking", body);
      if (
        response.data &&
        response.data.booking_result &&
        response.data.booking_result.success
      ) {
        setShowModal(true);
      } else {
        setFormSubmitError(
          (response.data &&
            response.data.booking_result &&
            response.data.booking_result.message) ||
            "Issue with submitting form."
        );
      }
    } catch (err) {
      console.error("createCompleteBooking (membership) error", err);
      setFormSubmitError("Issue with submitting form.");
    } finally {
      setIsLoading(false);
    }
  };

  const [userid, setUserId] = useState("");
  const [bookingid, setBookingId] = useState("");

  function checkUser(useremail, token = "") {
    console.info("Check User Called", {
      useremail: useremail,
      token: token,
    });
    usersService
      .getUserDetailsByUsername(useremail)
      .then((response) => {
        if (response.data[0] !== undefined) {
          // If user exist do not create user
          const dataid = response.data[0].id;
          console.info("User Exists", {
            user: dataid,
          });
          setUserId(dataid);
          if (values.hasUserMembership === false) {
            createUserMembership(values, dataid);
          }
          //createbookingentries
          //for (let cbe = 1; cbe <= parseInt(createbookingentries); cbe++) {
          createBookingDetails(dataid, token);
          //}
        } else {
          console.info("Not an existing user");
          console.log("Not an existing user");
          setUserId("");
          createUser(values, token);
        }
      })
      .catch((error) => {
        console.log("Check User error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
        setUserId("");
      });
  }

  function createUser(values, token = "") {
    console.info("Creating a User", {
      token: token,
      values: values,
    });
    var raw = {
      FirstName: values.Player1Firstname,
      LastName: values.Player1Lastname,
      email: values.Player1Email,
      username: values.Player1Email,
      password: values.Player1Password,
      confirmed: "false",
      Telephone: 0,
      MobileNumber: values.Player1Telephone,
      Status: "true",
      OptIn: values.OfferPromotionValue,
      blocked: "false",
      UserRole: "Customer",
      membership_catergory: 1,
      golf_courses: 1,
    };

    // NOTE: requires Public-role create permission on users-permissions.user
    // (or a custom endpoint). The booking flow may run pre-login.
    api
      .post("users/", raw)
      .then((response) => {
        console.log("User : " + JSON.stringify(response));
        console.info("User created", {
          response: response,
        });
        var useriddata = "";
        if (response.data.id !== null) {
          useriddata = response.data.id;
        } else {
          useriddata = response.data.data[0].id;
        }
        setUserId(useriddata);
        if (values.hasUserMembership === false) {
          createUserMembership(values, useriddata);
        }
        //for (let cbe = 1; cbe <= parseInt(createbookingentries); cbe++) {
        createBookingDetails(useriddata, token);
        //}
      })
      .catch((error) => {
        console.log("User error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
        setUserId("");
      });
  }

  function createUserMembership(values, userid) {
    console.info("Creating a membership", {
      user: userid,
      values: values,
    });
    var usermembershipraw = {
      PaymentDate: todaydate,
      Total: "0",
      UserID: parseInt(userid),
      MembershipID: 1,
      golf_courses: 1,
    };

    //Total: values.Player_Rate.toString(),

    /* axios
      .post(
        process.env.REACT_APP_ROOT_URL + "api::user-membership.user-membership",
        usermembershipraw,
        {
          headers: { Authorization: process.env.REACT_APP_ROOT_KEY },
        }
      ) */

    api
      .post("user-memberships/", { data: usermembershipraw })
      .then((response) => {
        //console.log("User Membership : ", response);
        /* for(let cbe=1;cbe <= parseInt(createbookingentries);cbe++) {
            createBookingDetails(userid);
          } */
      })
      .catch((error) => {
        console.log("User Membership error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
      });
  }

  function createBookingDetails(userid, token = "") {
    console.info("Creating Booking", {
      userid: userid,
      token: token,
    });
    var bookingdetailsraw = {
      tee_time_slot: parseInt(values.SelectedSlotId),
      users_permissions_user: parseInt(userid),
      BookingDate: moment(values.date).format("yyyy-MM-DD[T]HH:mm:ss.SSS[Z]"),
      Status: true,
      OtherPlayers: [],
      hasUserMembership: values.hasUserMembership,
      // Non-schema fields passed through to the afterCreate lifecycle so the
      // confirmation email can show the discount before payment-detail exists.
      coupon_code: couponApplied ? couponCode : "",
      coupon_discount: couponApplied ? couponDiscount : 0,
    };

    for (let index = 2; index <= parseInt(values.Player_Count); index++) {
      if (
        values["Player" + index + "Firstname"] == undefined ||
        values["Player" + index + "Firstname"] == ""
      ) {
        bookingdetailsraw.OtherPlayers.push("Player " + index);
      } else {
        if (
          values["Player" + index + "Lastname"] == undefined ||
          values["Player" + index + "Lastname"] == ""
        ) {
          bookingdetailsraw.OtherPlayers.push(
            values["Player" + index + "Firstname"]
          );
        } else {
          bookingdetailsraw.OtherPlayers.push(
            values["Player" + index + "Firstname"] +
            " " +
            values["Player" + index + "Lastname"]
          );
        }
      }
    }
    console.info("Booking Data", {
      bookingData: bookingdetailsraw,
    });

    /* axios
      .post(
        process.env.REACT_APP_ROOT_URL +
          "api::tee-time-booking-detail.tee-time-booking-detail",
        bookingdetailsraw,
        {
          headers: { Authorization: process.env.REACT_APP_ROOT_KEY },
        }
      ) */

    api
      .post("tee-time-booking-details/", { data: bookingdetailsraw })
      .then((response) => {
        console.log("Booking details response : ", JSON.stringify(response));
        console.info("Booking Created", {
          response: response,
        });

        var bookingresponse = response;
        var newbookingid = "";
        let bookingIdsArr = [];
        if (typeof bookingresponse.data.id !== "undefined") {
          newbookingid = bookingresponse.data.id;
        } else {
          newbookingid = bookingresponse.data.data.id;
        }
        bookingIdsArr.push(newbookingid);
        setBookingId(newbookingid);

        otherActivity(bookingdetailsraw, bookingIdsArr, userid, token);

        //window.location.href = "/";
      })
      .catch((error) => {
        console.log("Booking details error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
        setBookingId("");
      });
  }

  async function otherActivity(
    bookingdetailsraw,
    bookingIdsArr,
    userid,
    token
  ) {
    let promises = [];
    for (let index = 2; index <= parseInt(values.Player_Count); index++) {
      let visitorBookingId = 0;
      if (
        values["Player" + index + "Firstname"] == undefined ||
        values["Player" + index + "Firstname"] == ""
      ) {
        bookingdetailsraw.OtherPlayers.push("Player " + index);
        // Unique per booking so two parties booking the same slot don't end
        // up with indistinguishable "player2@..." visitor records.
        const _placeholderEmail =
          "player-" +
          (values.SelectedSlotId || "x") +
          "-" +
          Date.now() +
          "-" +
          index +
          "@golfteetime.co.uk";
        promises.push(
          Promise.resolve(
            createVisitorComplete(
              "Player " + index,
              "Temp",
              _placeholderEmail,
              "0",
              "0"
            )
          )
        );
      } else {
        if (
          values["Player" + index + "Lastname"] == undefined ||
          values["Player" + index + "Lastname"] == ""
        ) {
          promises.push(
            Promise.resolve(
              createVisitorComplete(
                values["Player" + index + "Firstname"],
                "",
                values.Player2Email,
                values.Player2Telephone,
                "0"
              )
            )
          );
        } else {
          promises.push(
            Promise.resolve(
              createVisitorComplete(
                values["Player" + index + "Firstname"],
                values["Player" + index + "Lastname"],
                values.Player2Email,
                values.Player2Telephone,
                "0"
              )
            )
          );
        }
      }

      //bookingIdsArr.push(visitorBookingId);
    }

    await Promise.all(promises)
      .then((results) => {
        console.log("All promises resolved with ", results);
        let all_ids = bookingIdsArr.concat(results);
        if (!values.isFMember) {
          all_ids = bookingIdsArr;
        }
        updateTeeTimeSlot(all_ids);
        CreatePaymentDetails(
          values.Player_Rate,
          values.Player_Rate,
          all_ids[0],
          parseInt(userid),
          all_ids,
          token
        );
        setShowModal(true);
        setClientSecret("");
      })
      .catch((error) => {
        console.log("Promise error" + JSON.stringify(error)); // rejectReason of any first rejected promise
      });
  }

  async function createVisitorComplete(
    firstname,
    lastname,
    email,
    mobile,
    bookingid
  ) {
    const visitorId = await createVisitorOnly(
      firstname,
      lastname,
      email,
      mobile,
      bookingid
    );
    console.log("VIsitor Id ", visitorId);
    let res = Promise.resolve(createVisitorBooking(visitorId));
    console.log("VIsitor Booking Id ", JSON.stringify(res));
    return res;
  }

  async function createVisitorOnly(
    firstname,
    lastname,
    email,
    mobile,
    bookingid
  ) {
    var visitorraw = {
      FirstName: firstname,
      LastName: lastname,
      Email: email,
      MobileNumber: parseInt(mobile),
      Bookingdetails: parseInt(bookingid),
      publishedAt: todaydate,
    };

    console.info("Create Visitor", {
      visitor: visitorraw,
    });

    /* axios
      .post(
        process.env.REACT_APP_ROOT_URL + "api::visitor-detail.visitor-detail",
        visitorraw,
        {
          headers: { Authorization: process.env.REACT_APP_ROOT_KEY },
        }
    ) */

    return api
      .post("visitor-details/", { data: visitorraw })
      .then((response) => {
        console.log("Visitor response : " + JSON.stringify(response));
        console.info(
          "Visitor reponse",
          JSON.stringify({
            response: response,
          })
        );


        if (response.data.hasOwnProperty('id')) {
          return response.data.id;
        } else {
          return response.data.data.id;
        }

      })
      .catch((error) => {
        console.log("Visitor error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
      });
  }

  function createVisitorBooking(visitor_id) {
    var bookingdetailsraw = {
      visitor_detail: visitor_id,
      tee_time_slot: parseInt(values.SelectedSlotId),
      BookingDate: moment(values.date).format("yyyy-MM-DD[T]HH:mm:ss.SSS[Z]"),
      Status: true,
      OtherPlayers: [],
      hasUserMembership: false,
    };
    console.info("Create Visitor Booking", {
      bookingdetails: bookingdetailsraw,
    });
    /* axios
     .post(
       process.env.REACT_APP_ROOT_URL +
         "api::tee-time-booking-detail.tee-time-booking-detail",
       bookingdetailsraw,
       {
         headers: { Authorization: process.env.REACT_APP_ROOT_KEY },
       }
     ) */
    return api
      .post("tee-time-booking-details/", { data: bookingdetailsraw })
      .then((response) => {
        console.info("Visitor Booking Created", {
          response: response,
        });
        //return response.data.id;
        if (response.data.hasOwnProperty('id')) {
          return response.data.id;
        } else {
          return response.data.data.id;
        }
      });
  }

  async function CreatePaymentDetails(
    green_fees_amount,
    total_amount,
    booking_id,
    user_id,
    booking_ids,
    token
  ) {
    const rawbody = {
      payment_type: "Online",
      green_fees_amount: green_fees_amount,
      total_amount: couponApplied ? parseFloat(finalRate) : total_amount,
      epos: 0,
      booking_id: booking_id,
      tee_time_booking_details: booking_ids,
      user_id: user_id,
      token: token,
      coupon_code: couponApplied ? couponCode : "",
      discount_amount: couponDiscount,
    };

    console.info("Create Payment", {
      data: rawbody,
    });

    /* axios
      .post(
        process.env.REACT_APP_ROOT_URL + "api::payment-detail.payment-detail",
        rawbody,
        {
          headers: { Authorization: process.env.REACT_APP_ROOT_KEY },
        }
      ) */
    api
      .post("payment-details/", { data: rawbody })
      .then((response) => {
        console.info("Payment response", {
          response: response,
        });
        console.log("Payment response : " + JSON.stringify(response));
        setIsLoading(false);
      })
      .catch((error) => {
        console.info("Payment response error ", {
          error: error,
        });
        console.log("Payment error : " + JSON.stringify(error));
        setFormSubmitError("Issue with submitting form.");
        setIsLoading(false);
      });
  }

  async function updateTeeTimeSlot(bookingIdsArr) {
    var updateraw = {};
    if (parseInt(values.maxPlayers) == parseInt(values.Player_Count)) {
      updateraw = {
        data: {
          AvailableSlots: "No",
          PlayersBooked: parseInt(values.Player_Count),
          tee_time_booking_details: bookingIdsArr,
        },
      };
    } else {
      updateraw = {
        data: {
          AvailableSlots: "Partial",
          PlayersBooked: parseInt(values.Player_Count),
          tee_time_booking_details: bookingIdsArr,
        },
      };
    }

    console.info("Tee Time Status update", {
      data: updateraw,
    });

    await api
      .put(
        "tee-time-slots/" + parseInt(values.SelectedSlotId),
        updateraw
      )
      .then((response) => {
        console.info("Tee Time Status updated", {
          response: response,
        });
        console.log("Tee Time Slot Updated.");
      })
      .catch((error) => {
        console.log(
          "updateTeeTimeSlot method error : " + JSON.stringify(error)
        );
        //setFormSubmitError("Issue with submitting form.");
      });
  }

  const onToken = (token) => {
    /* console.log(token, token.id);
      if(token.id != "") { */
    let allData = values;
    console.info(
      "Payment token - " + token + " other Data - " + JSON.stringify(allData)
    );
    console.log(
      "Payment token - " + token + " other Data - " + JSON.stringify(allData)
    );
    console.log(values);
    checkUser(values.Player1Email, token);
    /* } else {
        setFormSubmitError("Payment failed Please try after sometime.");
      } */
  };

  const triggerError = (result) => {
    console.log("Stripe Error" + JSON.stringify(result));
  };

  const setTermsConditions = (checkedvalue) => {
    //console.log(checkedvalue);
    setTermsConditionValue(checkedvalue);
    values.TermsConditionValue = checkedvalue;
    setFormData(values);
  };

  const setOfferAndPromotion = (checkedvalue) => {
    //console.log(checkedvalue);
    setOfferPromotionValue(checkedvalue);
    values.OfferPromotionValue = checkedvalue;
    setFormData(values);
  };

  const applyCoupon = async () => {
    if (!couponCode) {
      setCouponMessage("Please enter a coupon code");
      return;
    }
    setIsLoadingCoupon(true);
    setCouponMessage("");
    try {
      // /coupons/apply is already public (auth:false). Interceptor adds
      // no header in that case — request is clean.
      const response = await api.post("coupons/apply", {
        code: couponCode,
        booking_total: originalRate,
      });
      const resData = response.data;
      if (resData.valid && resData.data) {
        const coupon = resData.data;
        let discount = 0;
        let displayText = "";
        const discountAmt = parseFloat(coupon.discount_amount);

        if (coupon.discount_type === "percentage") {
          discount = (originalRate * discountAmt) / 100;
          displayText = `${discountAmt}%`;
        } else {
          discount = discountAmt;
          displayText = `£${discount.toFixed(2)}`;
        }

        if (isNaN(discount)) discount = 0;
        if (discount > originalRate) discount = originalRate;

        setCouponDiscount(discount);
        setCouponDisplay(displayText);
        setCouponApplied(true);
        setCouponMessage(`Discount of ${displayText} applied!`);
      } else {
        setCouponMessage(resData.message || "Invalid coupon code");
        setCouponDiscount(0);
        setCouponApplied(false);
      }
    } catch (err) {
      console.error("Coupon error", err);
      setCouponMessage(
        err.response?.data?.message || "Error verifying coupon"
      );
    }
    setIsLoadingCoupon(false);
  };

  // Memoised — only rebuilds when player count or the values object identity
  // changes. Previously this function was called inline on every render, so
  // every coupon/terms toggle re-created the entire card list (audit HIGH 7).
  const playerReviewCards = useMemo(() => {
    const playercard = [];
    const count = parseInt(values.Player_Count) || 0;
    for (let i = 2; i <= count; i++) {
      playercard.push(
        <Playerreviewcard
          key={i}
          backToPersonal={backToPersonal}
          values={values}
          playerNumber={i}
        />
      );
    }
    return playercard;
  }, [values, values.Player_Count, backToPersonal]);
  // Back-compat shim: existing JSX calls playerReviewDiv() as a function.
  const playerReviewDiv = () => playerReviewCards;

  const token = localStorage.getItem("token");
  let userData = localStorage.getItem("userData");
  if (userData) {
    userData = JSON.parse(userData);
  }

  var classnameinprogress = "review_info";

  var selectedslotdate = "";
  if (typeof values.date !== "undefined") {
    selectedslotdate = moment(values.date, "yyyy-MM-DD").format("DD-MM-YYYY");
  }

  const showPaymentPopup = () => {
    setIsLoading(true);
    if (parseInt(values.Player_Rate) !== 0) {
      if (PAYMENT_PROVIDER === "worldpay") {
        // Worldpay path: skip Stripe intent fetch and open WorldPayModal.
        setShowWorldpayModal(true);
        setFormSubmitError("");
        setIsLoading(false);
        return;
      }
      // Public endpoint (auth:false). NOTE: backend re-derives the
      // authoritative amount from the slot's stored Price * playerCount
      // and refuses mismatched values — the URL-supplied amount here is
      // just a sanity check.
      api
        .post("createStripeIntent", {
          amount: parseFloat(finalRate),
          email: values.Player1Email,
          firstname: values.Player1Firstname,
          lastname: values.Player1Lastname,
          selectedSlot: values.SelectedSlotId,
          playerCount: values.Player_Count,
          telephone: values.Player1Telephone,
          couponCode: couponApplied ? couponCode : "",
        })
        .then((response) => {
          // Do NOT log `response` — it carries the Stripe client secret.
          setClientSecret(response.data.clientSecret);
          //setIsLoading(false);
        })
        .catch((error) => {
          setFormSubmitError(
            error.response?.data?.error?.message ||
              error.response?.data?.message ||
              "Unable to start payment. Please try again.",
          );
          setIsLoading(false);
        });
    } else {
      submitMembership();
    }
  };

  const closePaymentPopup = () => {
    setClientSecret("");
    setIsLoading(false);
  };

  const closeWorldpayPopup = () => {
    setShowWorldpayModal(false);
    setIsLoading(false);
    setIsAPIProcessing(false);
  };

  const resolveWorldpayResponse = async (responseData, originalBody, depth = 0) => {
    if (depth > 4) {
      throw new Error("Worldpay 3DS flow returned too many continuation steps.");
    }

    if (
      responseData &&
      responseData.booking_result &&
      responseData.booking_result.success
    ) {
      return responseData;
    }

    if (responseData && responseData.three_ds && responseData.wp3ds_token) {
      const { three_ds } = responseData;
      const continueBody = {
        ...originalBody,
        wp3ds_token: responseData.wp3ds_token,
      };

      if (three_ds.stage === "device_data") {
        setFormSubmitError("");
        const collectionReference = await runDeviceDataCollection(three_ds);
        continueBody.collection_reference = collectionReference;
      } else if (three_ds.stage === "challenge") {
        setFormSubmitError("");
        await runChallenge(three_ds);
      } else {
        throw new Error("Unsupported Worldpay 3DS step.");
      }

      const continueResponse = await api.post(
        "worldpay/3ds/continue",
        continueBody
      );
      return resolveWorldpayResponse(
        continueResponse.data,
        originalBody,
        depth + 1
      );
    }

    return responseData;
  };

  /**
   * Called by WorldPayModal once it has a Worldpay session token. Posts the
   * full booking + payment + visitor + user payload to /worldpay/pay; the
   * backend authorizes the card and then runs createCompleteBooking (which
   * persists user, booking, payment-detail, coupon, etc).
   */
  const triggerWorldpayPayment = async (sessionToken, cardHolderName) => {
    setIsAPIProcessing(true);
    setFormSubmitError("");

    // Final blocked-email gate before charging the card. The on-blur and
    // PersonalInfo gates should already have caught this, but we re-check
    // here because the user could have edited the email in another tab,
    // or skipped a step via back/forward navigation.
    if (values.Player1Email) {
      try {
        const status = await usersService.checkEmailStatus(values.Player1Email);
        if (status && status.blocked) {
          setIsAPIProcessing(false);
          setFormSubmitError("This email cannot be used for booking.");
          return;
        }
      } catch (e) {
        // Soft-fail — backend payAndBook will still enforce the gate.
        console.log("Pre-submit email status check failed:", e);
      }
    }

    // Per-browser reservation token. The server uses this to verify that
    // the active hold on the slot belongs to this customer before claiming
    // the seats (prevents another browser from booking over our hold).
    // C4 audit: prefer the server-issued signed JWT (set by Booking.js) and
    // fall back to the legacy raw id for already-deployed FE bundles.
    // Signed JWT only — backend no longer accepts legacy raw tokens.
    const reservationToken = localStorage.getItem("u_b_id_jwt") || "";

    const body = {
      // Server-side: createCompleteBooking matches this against the slot's
      // ReservedBy column under a row-level lock. Mismatch → 0/error.
      user_token: reservationToken,
      user_data: {
        first_name: values.Player1Firstname,
        last_name: values.Player1Lastname,
        email: values.Player1Email,
        username: values.Player1Email,
        password: values.Player1Password,
        mobile_number: values.Player1Telephone,
      },
      booking_data: {
        tee_time_slot: parseInt(values.SelectedSlotId),
        BookingDate: moment(values.date).format("yyyy-MM-DD[T]HH:mm:ss.SSS[Z]"),
        Status: true,
        OtherPlayers: [],
        hasUserMembership: values.hasUserMembership,
        playerCount: values.Player_Count,
        coupon_code: couponApplied ? couponCode : "",
        coupon_discount: couponApplied ? couponDiscount : 0,
        // Shared-tee-time consent captured at slot selection (Pick_a_date).
        shared_tee_accepted: !!values.shared_tee_accepted,
        shared_tee_context: values.shared_tee_context || "",
      },
      visitor_data: [],
      payment_data: {
        payment_type: "Online",
        green_fees_amount: values.Player_Rate,
        total_amount: parseFloat(finalRate),
        token: sessionToken,
        card_holder_name: cardHolderName || "",
        coupon_code: couponApplied ? couponCode : "",
        discount_amount: couponApplied ? couponDiscount : 0,
      },
      device_data: buildDeviceData(),
      return_url: getWorldpayReturnUrl(),
    };

    const _bookingStamp = Date.now();
    for (let i = 2; i <= parseInt(values.Player_Count); i++) {
      const fname = values["Player" + i + "Firstname"];
      const lname = values["Player" + i + "Lastname"];
      const safeFirst = fname && fname !== "" ? fname : "Player " + i;
      const safeLast = lname && lname !== "" ? lname : "";
      // Unique per booking — see note above.
      const _email =
        "player-" +
        (values.SelectedSlotId || "x") +
        "-" +
        _bookingStamp +
        "-" +
        i +
        "@golfteetime.co.uk";
      body.visitor_data.push({
        FirstName: safeFirst,
        LastName: safeLast,
        Email: _email,
        golf_courses: 1,
      });
      body.booking_data.OtherPlayers.push(
        safeLast ? safeFirst + " " + safeLast : safeFirst
      );
    }

    try {
      // Public endpoint (auth:false). Capacity + ownership + price are
      // all enforced server-side inside payAndBook.
      const response = await api.post("worldpay/pay", body);
      console.info("Worldpay response", response.data);
      const resolved = await resolveWorldpayResponse(response.data, body);
      if (resolved && resolved.booking_result && resolved.booking_result.success) {
        setTransactionReference(
          resolved.booking_result.transaction_reference || ""
        );
        setShowModal(true);
        setShowWorldpayModal(false);
      } else {
        setFormSubmitError(
          (resolved &&
            resolved.booking_result &&
            resolved.booking_result.message) ||
            "Payment was not authorized."
        );
      }
    } catch (err) {
      console.error("Worldpay error", err);
      setFormSubmitError("Issue processing payment. Please try again.");
    } finally {
      setIsAPIProcessing(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="">
      {showModal ? <Modal transactionReference={transactionReference} /> : null}
      <div className="w-full px-[10px] md:px-[50px] py-4 bg-[#fafafa]">
        <div className="w-full bg-white md:shadow-md md:border md:border-gray-200 rounded-lg">
          <div className="">
            <div className="w-full bg-white shadow-md border border-gray-200 rounded-lg px-[10px] py-[10px] md:px-[40px] md:py-[30px]">
              <p className="text-[14pt] md:text-[30px] text-[#4E4E4E] font-semibold px-6">
                Booking Overview
              </p>
              <div className="flex items-center justify-center">
                <div className="bg-white md:shadow-lg md:border md:border-gray-200 rounded-[1rem] md:m-8 p-4 w-full">
                  <div
                    className={
                      parseInt(values.Player_Count) > 1
                        ? "w-full md:flex justify-center md:divide-x divide-gray-200"
                        : "w-full justify-center md:divide-x divide-gray-200"
                    }
                  >
                    <div className="left-card w-full md:px-4">
                      <div className="info-div">
                        <div className="flex items-start mb-4">
                          <p className="text-[14pt] md:text-[24px] text-[#707070] font-semibold">
                            Your information
                          </p>
                          <button
                            className="text-[14pt] md:text-[20px] text-[#0044FF] hover:underline ml-auto dark:text-blue-500"
                            onClick={backToPersonal}
                          >
                            EDIT
                          </button>
                        </div>
                        <div className="grid grid-cols-1 py-4 md:py-8 bg-gray-200 rounded-md block w-full px-2">
                          <div className="grid grid-cols-2 gap-6 md:px-[40px]">
                            <label className="block">
                              <p className="text-[#707070] font-medium text-[12pt] md:text-[18px]">
                                First Name
                              </p>
                              <p className="text-[#707070] font-semibold   mb-2 text-[14pt] md:text-[24px]">
                                {values.Player1Firstname}
                              </p>
                            </label>
                            <label className="block">
                              <p className="text-[#707070] font-medium text-[12pt] md:text-[18px] mb-2">
                                Last Name
                              </p>
                              <p className="text-[#707070] font-semibold   mb-2 text-[14pt] md:text-[24px]">
                                {values.Player1Lastname}
                              </p>
                            </label>
                          </div>
                          <div
                            className={
                              parseInt(values.Player_Count) > 1
                                ? "grid grid-cols-1 gap-6 md:px-[40px]"
                                : "grid grid-cols-2 gap-6 md:px-[40px]"
                            }
                          >
                            <label className="block">
                              <p className="text-[#707070] font-medium text-[12pt] md:text-[18px] mb-2">
                                Email
                              </p>
                              <p className="text-[#707070] font-semibold   mb-2 text-[14pt] md:text-[24px]">
                                {values.Player1Email}
                              </p>
                            </label>
                          </div>
                          <div
                            className={
                              parseInt(values.Player_Count) > 1
                                ? "grid grid-cols-1 gap-6 md:px-[40px]"
                                : "grid grid-cols-2 gap-6 md:px-[40px]"
                            }
                          >
                            <label className="block">
                              <p className="text-[#707070] font-medium text-[12pt] md:text-[18px] mb-2">
                                Telephone
                              </p>
                              <p className="text-[#707070] font-semibold   mb-2 text-[14pt] md:text-[24px]">
                                {values.Player1Telephone}
                              </p>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="booking-div py-6 ">
                        <p className="text-[#707070] font-semibold py-4 text-[14pt] md:text-[24px]">
                          Booking Details
                        </p>
                        <div className="block w-full md:shadow-none shadow-md md:border-none border md:rounded-none rounded-lg md:p-0 p-4">
                          <div className="flex md:items-center justify-start pb-1">
                            <p className="bg-gray-200 text-left text-[#707070] font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                              TOTAL BOOKING FEE
                            </p>
                            <p className="text-left text-[#707070] font-medium text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                              {"\u00A3" + values.Player_Rate}
                            </p>
                          </div>
                          {couponApplied && (
                            <>
                              <div className="flex md:items-center justify-start pb-1">
                                <p className="bg-green-50 border-l-4 border-green-400 text-left text-green-700 font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                                  DISCOUNT {couponDisplay ? `(${couponDisplay})` : ""}
                                </p>
                                <p className="text-left text-green-600 font-semibold text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                                  -£{couponDiscount.toFixed(2)}
                                </p>
                              </div>
                              <div className="flex md:items-center justify-start pb-1">
                                <p className="bg-gray-200 text-left text-[#707070] font-bold text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                                  FINAL PAYABLE
                                </p>
                                <p className="text-left text-[#707070] font-bold text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                                  £{finalRate}
                                </p>
                              </div>
                            </>
                          )}
                          <div className="flex md:items-center justify-start pb-1">
                            <p className="bg-gray-200 text-left text-[#707070] font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                              BOOKING TIME & DATE
                            </p>
                            <p className="text-left text-[#707070] font-medium text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                              {values.selectedslot} {selectedslotdate}
                            </p>
                          </div>
                          <div className="flex md:items-center justify-start pb-1 hidden">
                            <p className="bg-gray-200 text-left text-[#707070] font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                              COURSE
                            </p>
                            <p className="text-left text-[#707070] font-medium text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                              1st TEE
                            </p>
                          </div>
                          <div className="flex md:items-center justify-start pb-1 hidden">
                            <p className="bg-gray-200 text-left text-[#707070] font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                              HOLES
                            </p>
                            <p className="text-left text-[#707070] font-medium text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                              18
                            </p>
                          </div>
                          <div className="flex md:items-center justify-start pb-1">
                            <p className="bg-gray-200 text-left text-[#707070] font-medium text-[14pt] md:text-[20px] rounded-none px-1.5 py-1 w-full md:w-[270px]">
                              NUMBER OF PLAYERS
                            </p>
                            <p className="text-left text-[#707070] font-medium text-[14pt] md:text-[20px] px-8 py-1 w-full md:w-[270px]">
                              {values.Player_Count}
                            </p>
                          </div>
                        </div>
                      </div>

                      {/* APPLY COUPON SECTION */}
                      <div className="py-6">
                        <p className="text-[#707070] font-semibold py-4 text-[14pt] md:text-[24px]">
                          Have a Coupon?
                        </p>
                        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                          {!couponApplied ? (
                            <>
                              <p className="text-[#707070] text-sm mb-3">
                                Enter your coupon code below to apply a discount to your booking.
                              </p>
                              <div className="flex flex-col sm:flex-row gap-3">
                                <input
                                  type="text"
                                  className="border border-gray-300 rounded px-4 py-2.5 w-full focus:outline-none focus:ring-2 focus:ring-[#17BA17] focus:border-transparent text-[#707070] uppercase tracking-wider placeholder:normal-case placeholder:tracking-normal"
                                  placeholder="Enter coupon code"
                                  value={couponCode}
                                  onChange={(e) => setCouponCode(e.target.value.toUpperCase())}
                                  onKeyDown={(e) => e.key === "Enter" && applyCoupon()}
                                />
                                <button
                                  type="button"
                                  className="bg-[#17BA17] text-white px-6 py-2.5 rounded font-medium w-full sm:w-auto min-w-[120px] hover:bg-green-600 transition-colors duration-200 focus:outline-none disabled:opacity-60 disabled:cursor-not-allowed"
                                  onClick={applyCoupon}
                                  disabled={isLoadingCoupon}
                                >
                                  {isLoadingCoupon ? (
                                    <FaSpinner className="animate-spin mx-auto" />
                                  ) : (
                                    "Apply"
                                  )}
                                </button>
                              </div>
                              {couponMessage && (
                                <p className="mt-2 text-sm text-red-500 font-medium">
                                  {couponMessage}
                                </p>
                              )}
                            </>
                          ) : (
                            <div className="flex items-center justify-between flex-wrap gap-3">
                              <div className="flex items-center gap-3 flex-wrap">
                                <div className="flex items-center bg-green-100 border border-green-300 rounded-full px-4 py-1.5">
                                  <svg
                                    className="w-4 h-4 text-green-600 mr-2 flex-shrink-0"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M5 13l4 4L19 7"
                                    />
                                  </svg>
                                  <span className="text-green-700 font-semibold text-sm tracking-wider">
                                    {couponCode}
                                  </span>
                                </div>
                                <p className="text-green-600 font-medium text-sm">
                                  {couponMessage}
                                </p>
                              </div>
                              <button
                                type="button"
                                className="text-sm text-red-500 hover:text-red-700 hover:underline focus:outline-none"
                                onClick={() => {
                                  setCouponCode("");
                                  setCouponDiscount(0);
                                  setCouponDisplay("");
                                  setCouponApplied(false);
                                  setCouponMessage("");
                                }}
                              >
                                Remove
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="right-card w-full md:px-4">
                      {playerReviewDiv()}
                    </div>
                  </div>
                  <div className="grid pb-6">
                    <form
                      id="check-form"
                      name="check-form"
                      method="POST"
                      onSubmit={handleSubmit(showPaymentPopup)}
                    >
                      <label className="inline-flex items-center">
                        <input
                          type="checkbox"
                          className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-offset-0 focus:ring-indigo-200 focus:ring-opacity-50"
                          onClick={(e) => setTermsConditions(e.target.checked)}
                          {...register("termsCondition")}
                          name="termsCondition"
                          id="termsCondition"
                        />
                        <span className="ml-4 font-normal text-[#939393]">
                          I have read and accept the Booking Terms and
                          Conditions, especially with regard to refunds.{" "}
                          <a
                            className="text-blue-500 underline"
                            href="https://thorneypark.com/green-fees/"
                            target="_blank"
                          >
                            (Click here for terms and conditions)
                          </a>
                        </span>
                      </label>
                      <div className="ml-8 mb-2 text-left text-red-500 text-xs mt-1 italic first-letter:capitalize">
                        {errors.termsCondition?.message}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="md:flex items-center justify-end text-center p-4">
                <button
                  className="text-[12pt] md:text-[18px] font-medium bg-[#707070] text-white  px-5 py-2.5 rounded md:w-[280px] w-full md:mx-2 my-2 md:my-0"
                  onClick={backToPersonal}
                >
                  Back
                </button>
                {isLoading && (
                  <button
                    type="submit"
                    form="check-form"
                    className="inline-flex justify-center text-[12pt] md:text-[18px] font-medium bg-[#17BA17] text-white px-5 py-2.5 rounded md:w-[280px] w-full md:mx-2 my-2 md:my-0"
                    disabled
                  >
                    <FaSpinner icon="spinner" className="spinner" />{" "}
                    &nbsp;Processing
                  </button>
                )}

                {!isLoading && (
                  <button
                    type="submit"
                    form="check-form"
                    className="inline-flex justify-center text-[12pt] md:text-[18px] font-medium bg-[#17BA17] text-white px-5 py-2.5 rounded md:w-[280px] w-full md:mx-2 my-2 md:my-0"
                  >
                    Confirm Booking
                  </button>
                )}
              </div>
              <div className="place-items-center py-4">
                <p className="text-center text-[#ff0000] text-[14px]">
                  {formSubmitError}
                </p>
              </div>
              {clientSecret && (
                <>
                  <div
                    className="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center bg-[#000000ad]"
                    id="modal-id"
                  >
                    <div className="relative w-auto my-6 mx-auto max-w-2xl">
                      <div className=" border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                        <Elements
                          stripe={stripePromise}
                          options={{ clientSecret: clientSecret }}
                        >
                          <CheckoutForm
                            triggerAPI={onToken}
                            triggerError={triggerError}
                            closeModal={closePaymentPopup}
                            isProcessingApi={isLoading}
                          />
                        </Elements>
                      </div>
                    </div>
                  </div>
                  <div
                    className="hidden opacity-25 fixed inset-0 z-40 bg-black"
                    id="modal-id-backdrop"
                  ></div>
                </>
              )}
              {showWorldpayModal && (
                <WorldPayModal
                  closeModal={closeWorldpayPopup}
                  triggerAPI={triggerWorldpayPayment}
                  message={formSubmitError}
                  isAPIProcessing={isAPIProcessing}
                  amount={parseFloat(finalRate)}
                  subtotal={originalRate}
                  discount={couponApplied ? couponDiscount : 0}
                  couponCode={couponApplied ? couponCode : ""}
                  teeTime={values.date}
                  playerCount={values.Player_Count}
                  playerName={
                    (values.Player1Firstname || "") +
                    (values.Player1Lastname ? " " + values.Player1Lastname : "")
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
